import React, {useState, useRef} from "react";
import {connect} from "react-redux";
import classNames from "classnames";
import {MainBg2, CloudBot, CloudTop} from 'view/images/index'
import MainBg from 'view/images/mainBg'
import gsap from "gsap";

function Section01() {

    const [mxScroll, maxScroll] = useState(false);
    const [imgScroll, svgScroll] = useState(false);
    const ROOT = document.documentElement;
    const MIN = 20;
    const THRESHOLD = window.innerHeight * (1.2 - 0.225);
    const update = e => {
        const scroll = Math.floor(window.scrollY / window.innerHeight * 100);
        ROOT.style.setProperty('--scroll', Math.max(0, Math.min(scroll, 100 - MIN)));
        maxScroll(scroll > Math.max(0, Math.min(scroll, 100)))
        ROOT.style.setProperty('--cloud', Math.max(0, Math.min(scroll, 150)));
        ROOT.style.setProperty('--pad', Math.max(0, Math.min(scroll, 100)));
        svgScroll(Math.max(0, Math.min(scroll, 100)))
        const id = document.getElementById("pad");
        console.log(Math.max(0, Math.min(scroll, 1400)))

    };
    window.addEventListener('scroll', update);

    return (
        <React.Fragment>
            <article className="section01">
                <CloudBot/>
                <CloudTop/>

                <div
                    id="pad"
                    className={classNames("pad",
                        {
                            positionFixed: mxScroll == false,
                            positionSticky: mxScroll == true
                        })
                    }
                >

                    <MainBg svgScroll={imgScroll}/>
                    <img src="/images/portfolio_mainBg.jpg" className="mobilePic"/>
                    <img src="/images/pad.png" className="tab"/>

                    <div className="imgTxt opa0">
                        <div className="_imgTxt-title">
                            Publisher, <br/>
                            Hoya
                        </div>
                        <div className="_imgTxt-content">
                            #애니메이션을좋아하는 #궁금증이많은
                        </div>
                    </div>

                    <div className="imgTxt opa1">
                        <div className="_imgTxt-title">
                            윤호의 웹 세상
                        </div>
                        <div className="_imgTxt-content">
                            @i_yoonho
                        </div>
                    </div>
                </div>
                <div className="wrap text_line">
                    <div className="_text-title">반가워요 !</div>
                    <div className="_text-h2">이윤호라고 합니다</div>
                    <div className="_text-content">
                        저는 애니메이션 만들기를 좋아하는<br/>
                        웹 퍼블리셔 입니다. <br/>
                        <br/>
                        궁금증이 많아 이것 저것 따라하기를 좋아하고,<br/>
                        맘에 든건 해봐야 직성이 풀리는 성격의 소유자입니다.<br/>
                        <br/>
                        가끔 궁금증이 많은게 독이 되기도 하지만,<br/>
                        열심히 만들었으니 여러분들이 좋아했으면 좋겠어요!! <br/>
                        <br/>
                        남들이 기억해 주는 프로젝트를 만드는 것이<br/>
                        제 꿈이랍니다 :)
                        <br/>
                        뚝딱 뚝딱 열심히 만들었어요.<br/>
                    </div>
                </div>
            </article>
        </React.Fragment>
    );
}

export default connect(
    // props 로 넣어줄 스토어 상태값
    (state) => ({
        layout: state.layout,
    })
)(Section01);

